(() => { if (window.BEAEPAGEJS === undefined) {
            window.BEAEPAGEJS = [];
          }

          if(window.beaePageSetting == undefined) {
            window.beaePageSetting = {};
          }
          
          window.beaePageSetting.pageId = "68b05f244cb0de347809dfe2";
              window.beaePageSetting.pageTitle = "Reader Review Slides"; 
              window.beaePageSetting.pageType = "section";

          let js_BAN3P5I5 = () => { let BeaeUseHooks = {};
      try {
        let argid = 'beae-pva23l4hsection-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pva23l4h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pva23l4h');
        args.el = args.els[0];
        ((t) => { var o;if((o=t.el.querySelector(".beae-grid-system"))==null||o.addEventListener("scroll",a=>{var r,l;let n=a.target;if(!n.classList.contains("beae-grid-carousel"))return;let s=Math.round((n.scrollLeft+n.querySelector(".beae-grid-carousel__snaps").offsetLeft)/(n.offsetWidth*.8))+1;(r=t.el.querySelector(".beae-grid-carousel__pagination div.active"))==null||r.classList.remove("active"),(l=t.el.querySelector('.beae-grid-carousel__pagination div[data-index="'+s+'"]'))==null||l.classList.add("active")}),t.mode.value=="live"){const a=t.el.querySelector('.beae-section-background-video[data-device="desktop"]'),n=t.el.querySelector('.beae-section-background-video[data-device="mobile"]'),s=[];window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection&&(window.innerWidth>=768?a&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a)&&s.push("desktop"):n&&window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n)&&s.push("mobile")),(a||n)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!s.includes("desktop")&&window.innerWidth>=768&&a){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideo,a);r&&(a.innerHTML=r.html,s.push("desktop"))}if(!s.includes("mobile")&&window.innerWidth<768&&n){const r=window.BEAEVIDEO.convertBackgroundSection(t.optionsVideoMobile,n);r&&(n.innerHTML=r.html,s.push("mobile"))}}})}t.el.querySelectorAll(".beae-text-highlight").forEach(a=>{new IntersectionObserver((s,r)=>{s.forEach(l=>{l.isIntersecting&&(l.target.querySelectorAll("path, line").forEach(c=>{c.style.strokeDasharray=parseFloat(c.getAttribute("data-dash-ratio")*l.target.offsetWidth*2)+"px, 999999px"}),r.unobserve(l.target))})},{root:document,rootMargin:"0px 0px -40%"}).observe(a)}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pva23l4h: ', ex)
      };
    

      try {
        let argid = 'beae-pva23l4hsection-slide-show',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-pva23l4h',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-pva23l4h');
        args.el = args.els[0];
        ((h) => { window.BeaeSlider&&!h.noRunJs&&window.BeaeSlider(h) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-pva23l4h: ', ex)
      };
    

      try {
        let argid = 'beae-8umw0uimblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8umw0uim',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8umw0uim');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8umw0uim: ', ex)
      };
    

      try {
        let argid = 'beae-efn1vja3block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-efn1vja3',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-efn1vja3');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-efn1vja3: ', ex)
      };
    

      try {
        let argid = 'beae-lv70f0z2button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-lv70f0z2',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-lv70f0z2');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-lv70f0z2: ', ex)
      };
    

      try {
        let argid = 'beae-uvl0nslqslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-uvl0nslq',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-uvl0nslq');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-uvl0nslq: ', ex)
      };
    

      try {
        let argid = 'beae-8wppd60dblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-8wppd60d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-8wppd60d');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-8wppd60d: ', ex)
      };
    

      try {
        let argid = 'beae-m4ihq5srblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-m4ihq5sr',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-m4ihq5sr');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-m4ihq5sr: ', ex)
      };
    

      try {
        let argid = 'beae-cdrls9s4button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-cdrls9s4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-cdrls9s4');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-cdrls9s4: ', ex)
      };
    

      try {
        let argid = 'beae-kf0wvm3kslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-kf0wvm3k',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-kf0wvm3k');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-kf0wvm3k: ', ex)
      };
    

      try {
        let argid = 'beae-76qxql3dblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-76qxql3d',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-76qxql3d');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-76qxql3d: ', ex)
      };
    

      try {
        let argid = 'beae-grrf9oq9block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-grrf9oq9',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-grrf9oq9');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-grrf9oq9: ', ex)
      };
    

      try {
        let argid = 'beae-xi6b17b5button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xi6b17b5',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xi6b17b5');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xi6b17b5: ', ex)
      };
    

      try {
        let argid = 'beae-xlp6e6sdslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-xlp6e6sd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-xlp6e6sd');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-xlp6e6sd: ', ex)
      };
    

      try {
        let argid = 'beae-9stefju0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-9stefju0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-9stefju0');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-9stefju0: ', ex)
      };
    

      try {
        let argid = 'beae-w6ixk1d0block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-w6ixk1d0',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-w6ixk1d0');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-w6ixk1d0: ', ex)
      };
    

      try {
        let argid = 'beae-7rqj0lm1button-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7rqj0lm1',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7rqj0lm1');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7rqj0lm1: ', ex)
      };
    

      try {
        let argid = 'beae-5te098fdslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5te098fd',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5te098fd');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5te098fd: ', ex)
      };
    

      try {
        let argid = 'beae-d0wclx3jblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-d0wclx3j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-d0wclx3j');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-d0wclx3j: ', ex)
      };
    

      try {
        let argid = 'beae-zdwrama7block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-zdwrama7',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-zdwrama7');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-zdwrama7: ', ex)
      };
    

      try {
        let argid = 'beae-g1zxfxlebutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-g1zxfxle',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-g1zxfxle');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-g1zxfxle: ', ex)
      };
    

      try {
        let argid = 'beae-alwcc3zxslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-alwcc3zx',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-alwcc3zx');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-alwcc3zx: ', ex)
      };
    

      try {
        let argid = 'beae-5qe969jfblock-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-5qe969jf',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-5qe969jf');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-5qe969jf: ', ex)
      };
    

      try {
        let argid = 'beae-4vwayia4block-text',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-4vwayia4',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-4vwayia4');
        args.el = args.els[0];
        ((P) => { var I;((I=P.el)==null?void 0:I.querySelectorAll(".beae-x-text a")).forEach(z=>{let O=z==null?void 0:z.getAttribute("href");z&&P.mode.value!=="builder"&&(O!=null&&O.includes("#"))&&z.addEventListener("click",A=>{let F=document.querySelector(O+","+(O==null?void 0:O.replace("#",".")));if(F)return F.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),A.preventDefault(),!1})}) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-4vwayia4: ', ex)
      };
    

      try {
        let argid = 'beae-7avpi6vmbutton-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-7avpi6vm',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-7avpi6vm');
        args.el = args.els[0];
        ((data) => { let buttonElm=data.el.querySelector("a.beae-button-js");buttonElm==null||buttonElm.addEventListener("click",e=>{let extOptions={};if(data.extendOptions)try{eval("extOptions = "+data.extendOptions)}catch(n){extOptions={},console.error(n)}if(data.mode.value==="builder")return e.preventDefault(),!1;let selector=e.currentTarget.getAttribute("href");if(selector.indexOf("#")===0&&selector!=="#"){let n=document.querySelector(selector+","+selector.replace("#","."));if(n)return n.scrollIntoView({behavior:"smooth",block:"center",inline:"center"}),e.preventDefault(),!1}if(data.type==="popup"){if(window.isPreviewTemplate){let t=data.el.querySelector(".beae-content-size-chart-preview");window.BeaePopupLibrary.createPopup(t,{id:data.id,...extOptions}),e.preventDefault();return}const n=window.createLoading(e.currentTarget);return window.BeaePopupLibrary.lightbox({id:data.id,url:((data==null?void 0:data.url)??"").replace("/popup/","/?view=beae-"),...extOptions}).then(t=>{t.querySelector(".beae-product-form-next")&&window.handleEventFormProductCard(t),n.remove()}),e.preventDefault(),!1}else if(data.type==="pages"&&data.lightbox){let n=data.pageContent.replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&amp;/g,"&").replace(/&quot;/g,'"').replace(/&#39;/g,"'");return window.isPreviewTemplate&&(n=data.el.querySelector(".beae-content-size-chart-preview")),window.BeaePopupLibrary.createPopup(n,{id:data.id,...extOptions}),e.preventDefault(),!1}}),data.type==="popup"&&data.lightbox&&new IntersectionObserver((t,o)=>{t.forEach(r=>{r.isIntersecting&&(o.unobserve(r.target),r.target.click())})}).observe(buttonElm) })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-7avpi6vm: ', ex)
      };
    

      try {
        let argid = 'beae-74jeb23jslider-item-js',
          args = window.BEAEARGS[argid];
        if (!args) {
          args = {
            id: 'beae-74jeb23j',
            mode: {value: 'live'}
          }
        };
        args.els = document.querySelectorAll('.beae-74jeb23j');
        args.el = args.els[0];
        ((w) => { if(w.mode.value=="live"){const x=w.el.querySelector('.beae-section-background-video[data-device="desktop"]'),M=w.el.querySelector('.beae-section-background-video[data-device="mobile"]'),L=[];if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(window.innerWidth>=768){if(x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}}else if(M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}(x||M)&&window.addEventListener("resize",()=>{if(window.BEAEVIDEO&&window.BEAEVIDEO.convertBackgroundSection){if(!L.includes("desktop")&&window.innerWidth>=768&&x){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideo,x);V&&(x.innerHTML=V.html,L.push("desktop"))}if(!L.includes("mobile")&&window.innerWidth<768&&M){const V=window.BEAEVIDEO.convertBackgroundSection(w.optionsVideoMobile,M);V&&(M.innerHTML=V.html,L.push("mobile"))}}})} })(args);
      }  catch (ex) {
        console.error('BEAE JS ERROR ID beae-74jeb23j: ', ex)
      };
    }; if (window.BEAEBASE) {js_BAN3P5I5()} else {window.BEAEPAGEJS.push(js_BAN3P5I5)} })(); 